<template>
    <div class="state">
        <div class="items"
             id="Item6">
            <a href="javascript:;"
               class="fold"></a>
            <div id="ChinaMap6"></div>
            <div id="ClickCallback"
                 style="font-size:14px; color:red"></div>
        </div>
        <div class="main">
            <span class="beijing">北京</span>
            <span class="shanghai">上海</span>
            <span class="tianjing">天津</span>
            <span class="hebei">河北</span>
            <span class="neimenggu">内蒙古</span>
            <span class="jiling">吉林</span>
            <span class="heilongjiang">黑龙江</span>
            <span class="niaoling">辽宁</span>
            <span class="xinjiang">新疆</span>
            <span class="ziazng">西藏</span>
            <span class="gansu">甘肃</span>
            <span class="ningxia">宁夏</span>
            <span class="qinghai">青海</span>
            <span class="sichuan">四川</span>
            <span class="yunnan">云南</span>
            <span class="shanxi">陕西</span>
            <span class="shaxi">山西</span>
            <span class="henan">河南</span>
            <span class="shandong">山东</span>
            <span class="jiangsu">江苏</span>
            <span class="anhui">安徽</span>
            <span class="hubei">湖北</span>
            <span class="chongqing">重庆</span>
            <span class="guizhou">贵州</span>
            <span class="hunan">湖南</span>
            <span class="guangxi">广西</span>
            <span class="guangdong">广东</span>
            <span class="jiangxi">江西</span>
            <span class="fujian">福建</span>
            <span class="zhejiang">浙江</span>
            <span class="hainan">海南</span>
            <span class="aomeng">澳门</span>
            <span class="xianggang">香港</span>
            <span class="taiwan">台湾</span>
        </div>
        <div class="imgs">
            <img src='@/assets/images/map1.png'/>
            <span class="text">南海诸岛</span>
        </div>
    </div>

</template>
<script>
import Bus from "@/utils/bus";
export default {
    name: "state",
    data() {
        return {};
    },
    mounted() {
        $(function() {
            $("#ChinaMap6").SVGMap({
                clickCallback: function(stateData, obj) {
                    setTimeout(() => {
                        Bus.$emit("toregion", obj.name);
                    }, 10);
                    // $("#ClickCallback").html("点击了：" + obj.name);
                }
            });
        });
    }
};
</script>
<style lang="scss" scoped>
@import "../../../public/style/state.css";
.state {
    width: 800px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    /deep/ #ChinaMap6 {
        width: 800px !important;
        height: 700px !important;
    }
    /deep/ svg {
        width: 800px;
        height: 700px;
    }
    .items {
        z-index: 999;
    }
    .main {
        // color: #fff;
        z-index: -1;
        span {
            font-size: 13px;
            position: absolute;
        }
        .beijing {
            // position: absolute;
            top: 250px;
            left: 576px;
        }
        .shanghai {
            bottom: 277px;
            right: 82px;
        }
        .tianjing {
            top: 270px;
            right: 174px;
        }
        .hebei {
            top: 301px;
            right: 209px;
        }
        .neimenggu {
            top: 261px;
            right: 298px;
        }
        .jiling {
            top: 190px;
            right: 68px;
        }
        .heilongjiang {
            top: 115px;
            right: 68px;
        }
        .niaoling {
            top: 237px;
            right: 105px;
        }
        .xinjiang {
            top: 237px;
            left: 195px;
        }
        .ziazng {
            top: 397px;
            left: 145px;
        }
        .gansu {
            top: 367px;
            left: 410px;
        }
        .ningxia {
            top: 310px;
            left: 440px;
        }
        .qinghai {
            top: 357px;
            left: 295px;
        }
        .sichuan {
            bottom: 227px;
            left: 400px;
        }
        .yunnan {
            bottom: 127px;
            left: 370px;
        }
        .shanxi {
            top: 382px;
            left: 474px;
        }
        .shaxi {
            top: 337px;
            right: 250px;
        }
        .henan {
            top: 389px;
            right: 223px;
        }
        .shandong {
            top: 337px;
            right: 164px;
        }
        .jiangsu {
            bottom: 305px;
            right: 137px;
        }
        .anhui {
            bottom: 256px;
            right: 158px;
        }
        .hubei {
            bottom: 256px;
            right: 244px;
        }
        .chongqing {
            bottom: 250px;
            right: 291px;
        }
        .guizhou {
            bottom: 180px;
            right: 303px;
        }
        .hunan {
            bottom: 180px;
            right: 234px;
        }
        .guangxi {
            bottom: 114px;
            right: 293px;
        }
        .guangdong {
            bottom: 129px;
            right: 209px;
        }
        .jiangxi {
            bottom: 180px;
            right: 184px;
        }
        .fujian {
            bottom: 165px;
            right: 137px;
        }
        .zhejiang {
            bottom: 225px;
            right: 111px;
        }
        .hainan {
            bottom: 31px;
            right: 234px;
        }
        .aomeng {
            bottom: 74px;
            right: 198px;
        }
        .xianggang {
            bottom: 93px;
            right: 169px;
        }
        .taiwan {
            bottom: 165px;
            right: 80px;
        }
    }
    .imgs{
        position: absolute;
        right: 0;
        bottom: 0;
        width: 70px;
        img{
            width: 100%;
        }
        .text{
            font-size: 13px;
            position: relative;
            top: -24px;
            left: 8px;
        }
    }
}
</style>

